var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import PhoneNumberInput, { isValidPhoneNumber } from 'react-phone-number-input';
import cx from 'classnames';
import keyCode from 'app/libs/keyCode';
import Validators from 'app/components/Form/Validators/Validators.jsx';
import classes from 'app/components/Form/PhoneInput/PhoneInput.module.scss';
export function PhoneInput(props) {
    const { value: defaultValue, validatorRef, errors, isRequired, validators, onExit, onValidate, onBlur: defaultOnBlur, style, onChange, autoFocus, defaultCountry = 'FR' } = props, rest = __rest(props, ["value", "validatorRef", "errors", "isRequired", "validators", "onExit", "onValidate", "onBlur", "style", "onChange", "autoFocus", "defaultCountry"]);
    const [error, setError] = useState(false);
    const [value, setValue] = useState(defaultValue || '');
    function onKeyDown(e) {
        switch (e.code) {
            case keyCode.ESCAPE:
                onExit === null || onExit === void 0 ? void 0 : onExit(e, value);
                break;
            case keyCode.ENTER:
                onValidate === null || onValidate === void 0 ? void 0 : onValidate(e, value);
                break;
            default:
                break;
        }
    }
    function onBlur(e) {
        if (onValidate && isValidPhoneNumber(value))
            onValidate(e, value);
        defaultOnBlur === null || defaultOnBlur === void 0 ? void 0 : defaultOnBlur(e, value);
    }
    function _onChange(val) {
        setValue(val);
        onChange === null || onChange === void 0 ? void 0 : onChange(val);
    }
    return (_jsxs("div", { className: classes.container, style: style, children: [_jsx(PhoneNumberInput, Object.assign({ defaultCountry: "FR", value: value, className: cx({ [classes.error]: error }, 'input'), onKeyDown: onKeyDown, onChange: _onChange, onBlur: onBlur, ref: (ref) => {
                    if (autoFocus)
                        ref === null || ref === void 0 ? void 0 : ref.select();
                } }, rest)), _jsx(Validators, { ref: (ref) => {
                    if (validatorRef) {
                        validatorRef(ref);
                    }
                }, className: classes.fieldError, value: value, errors: errors, onSuccess: () => setError(false), onError: () => setError(true), validators: Object.assign({ required: isRequired }, validators) })] }));
}
